import { DropzoneInputProps, DropzoneRootProps } from "react-dropzone";
import { useTranslation } from "react-i18next";

import UploadIcon from "@mui/icons-material/UploadRounded";
import { Box, Typography } from "@mui/material";

export type DropZoneUploadButtonSize = "small" | "medium";

interface Props {
  isDragActive: boolean;
  getRootProps: <T extends DropzoneRootProps>(props?: T) => T;
  getInputProps: <T extends DropzoneInputProps>(props?: T) => T;
  size?: DropZoneUploadButtonSize;
  label?: string;
}

export function DropZoneUploadButton({ isDragActive, getRootProps, getInputProps, size = "medium", label }: Props) {
  const { t } = useTranslation();
  const resolvedLabel = label ?? t("dropzone.panel.uploadFiles");

  return (
    <Box
      {...getRootProps()}
      sx={(theme) => ({
        position: "relative",
        flexShrink: 0,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: 1,
        border: "1px dashed",
        borderColor: isDragActive ? theme.palette.primary.main : theme.palette.fsw["blue-50"],
        backgroundColor: isDragActive ? theme.palette.action.hover : theme.palette.fsw["blue-5"],
        borderRadius: 0.5,
        color: theme.palette.primary.main,
        py: size === "small" ? 0.5 : 2,
        px: 1,
        cursor: "pointer",
      })}
    >
      <input {...getInputProps()} aria-label={resolvedLabel} />
      <UploadIcon />
      <Typography variant="body2">{resolvedLabel}</Typography>
    </Box>
  );
}
